
function filterLink($timeout, element, ngModelCtrl, stTableCtrl) {
    let timer = null;
    let input = element.find('input');

    input.on('input', function (evt) {
        evt = evt.originalEvent || evt;

        if (timer != null) {
            $timeout.cancel(timer);
        }

        timer = $timeout(() => {
            let value = evt.target.value || '';
            stTableCtrl.search(value, '');
            ngModelCtrl.$setViewValue(value);
            timer = null;
        }, 300);
    });

    ngModelCtrl.$render = function () {
        stTableCtrl.search(this.$viewValue, '');
        input.val(this.$viewValue);
    };
}

// This functions as a replacement for st-search that integrates with ngModel.
angular.module("tromanWeb").directive("ergoFilterInput", ['$timeout', function ($timeout) {
    return {
        restrict: 'E',
        require: ['ngModel', '^stTable'],
        template: function (_tElement, tAttrs) {
            return `<input type="text" class="form-control" placeholder="${tAttrs.placeholder}" />`;
        },
        link: function (_scope, element, _attributes, [ngModelCtrl, stTableCtrl]) {
            return filterLink($timeout, element, ngModelCtrl, stTableCtrl);
        }
    };
}]);

angular.module("tromanWeb").directive("ergoFilterPanel", ['$timeout', function ($timeout) {
    return {
        restrict: 'E',
        template: require('./ergoFilterPanel.html'),
        require: ['ergoFilterPanel', '^ergoTable', 'ngModel', '^stTable'],
        controllerAs: 'ctrl',
        scope: {},
        link: function (_scope, element, _attributes, [ergoFilterPanel, ergoTable, ngModelCtrl, stTableCtrl]) {
            ergoFilterPanel.table = ergoTable;
            return filterLink($timeout, element, ngModelCtrl, stTableCtrl);
        },
        controller: function () { },
    };
}]);